import i18next from 'i18next';
import * as Yup from 'yup';

export const inviteNewUserValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email(i18next.t('validationSchema.general.invalidEmailFormat'))
    .required(i18next.t('validationSchema.general.emailRequired')),
});
